import {useState} from "react";
import ExerciserTopContentLayout from "../../layouts/courses/exercisers/ExerciserTopContentLayout";
import ExerciserBottomBar from "../../bars/courses/exercisers/ExerciserBottomBar";
import {getLocalItemAsJsonFromKey, setLocalItemFromKey} from "../../../services/LocalStorage";
import {kSystemKeys} from "../../../constants/keys";
import {PositiveIntegerExpressionKeyboard} from "../../keyboards/PositiveIntegerExpressionKeyboard";
import Exerciser159QuestionText from "../../texts/courses/exercisers/Exerciser159QuestionText";
import Exerciser159SingleValueAnswerInput from "../../inputs/exercisers/Exerciser159SingleValueAnswerInput";
import Exerciser159BottomContentLayout from "../../layouts/courses/exercisers/Exerciser159BottomContentLayout";

export default function Exerciser159({ problem,
                                       setIsExerciserOver,
                                       currentIndex,
                                       setCurrentIndex }) {
    // UID : 159
    // Grade : 5e
    // Task : Traduire un programme de calcul avec une expression littérale
    // Notes : N/A

    // PROPERTIES
    const answerMaxLength = 14
    const operators = ["x", "+", "-"]
    const [userAnswer, setUserAnswer] = useState("");

    // BUILD
    return (
        <div className={"grow w-full flex flex-col justify-start items-center"}>
            <ExerciserTopContentLayout>
                <Exerciser159QuestionText question={problem?.questions[currentIndex].question}
                                          warning={problem?.questions[currentIndex].warning}/>
                <Exerciser159SingleValueAnswerInput value={userAnswer}
                                                    answerMaxLength={answerMaxLength}
                                                    placeholder={"ex : (2 + n) x 1"} />
            </ExerciserTopContentLayout>
            <Exerciser159BottomContentLayout>
                <PositiveIntegerExpressionKeyboard onKeyButtonPressed={onKeyButtonPressed}
                                                   isKeyButtonDisabled={isKeyButtonDisabled} />
                <ExerciserBottomBar isEraseButtonDisabled={isEraseButtonDisabled()}
                                    onEraseButtonPressed={onEraseButtonPressed}
                                    isValidationButtonDisabled={isValidateButtonDisabled()}
                                    onValidateButtonPressed={onValidateButtonPressed} />
            </Exerciser159BottomContentLayout>
        </div>
    );

    // METHODS
    // <<<< Erase button >>>>
    // ---- UX : Check if erase button is disabled
    function isEraseButtonDisabled() {
        return userAnswer.length === 0
    }

    // ---- LOGIC : On erase button pressed
    function onEraseButtonPressed() {
        setUserAnswer((prev) => {
            // Defense
            if (!prev) return "";
            const lastChar = prev.slice(-1);

            if (lastChar === " ") {
                // Case : operator has been written " " + operator + " " => delete 3 "letters"
                return prev.slice(0, -3);
            } else {
                // Case : delete one single letter
                return prev.slice(0, -1);
            }
        })
    }

    // <<<< Validation button >>>>
    // ---- UX : Check if validate button is disabled
    function isValidateButtonDisabled() {
        return !userAnswer
            || userAnswer.trim() === ""
            || operators.includes(userAnswer.slice(-1))
            || userAnswer.slice(-1) === "("
    }

    // ---- LOGIC : On validate button pressed
    function onValidateButtonPressed() {
        // Defense
        if (isValidateButtonDisabled())
            return

        // Process answer
        // ---- Create userSubmission object
        const normalizedAnswer = userAnswer.replace(/x/g, "\\times");
        const userSubmission = {
            answer: normalizedAnswer,
            isCorrect: problem.questions[currentIndex].answers.includes(userAnswer.replace(/\s+/g, ""))
        }
        // ---- Add user answer object to problem
        problem.questions[currentIndex] = {...problem.questions[currentIndex], userSubmission: userSubmission}
        // ---- LOCAL STORAGE : Update problem
        let localSession = getLocalItemAsJsonFromKey(kSystemKeys.session)
        localSession = {...localSession, problem: problem}

        // Navigate to next step
        if (currentIndex === problem?.questions?.length - 1) {
            // Case : it was last problem
            setIsExerciserOver(true)
            localSession = {...localSession, isExerciserOver: true}
        } else {
            // Case : question(s) left
            // ---- Reset state and increment currentIndex
            setUserAnswer("")
            const newCurrentIndex = currentIndex + 1;
            setCurrentIndex(newCurrentIndex)
            localSession = {...localSession, currentQuestion: newCurrentIndex}
        }
        // LOCAL STORAGE : Update local session
        setLocalItemFromKey(kSystemKeys.session, localSession)
    }

    // <<<< Key button >>>>
    // ---- UX : Check if key button is disabled (_ for unused parameter)
    function isKeyButtonDisabled(item) {
        if (userAnswer.length >= answerMaxLength)
            return true
        // Case : Operators
        if (item === 'n') {
            return userAnswer[0] === "0" || userAnswer.includes("n")
        } else if (item === '+' || item === '-' || item === 'x') {
            return userAnswer[0] === "0" || userAnswer.length === 0 || operators.includes(userAnswer.slice(-1)) || userAnswer.slice(-1) === "("
        } else if (item === '(' || item === ')') {
            return userAnswer[0] === "0" || userAnswer.slice(-1) === ")" || userAnswer.slice(-1) === "(" || operators.includes(userAnswer.slice(-1))
        } else {
            // Case : Numbers keys
            return userAnswer[0] === "0" && userAnswer.length === 1;
        }
    }

    // ---- LOGIC : On key button pressed
    function onKeyButtonPressed(item) {
        if (!isKeyButtonDisabled(item)) {
            if (operators.includes(item)) {
                const spacedItem = " " + item + " "
                setUserAnswer((prev) => prev + spacedItem)
            } else {
                setUserAnswer((prev) => prev + item)
            }
        }
    }
}